"use client";


import Style from "./Menu.module.scss";
import { RouteLink } from "../RouteLink";
import {startTransition, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";


export type MenuItem = {
    title: string,
    url: string,
    active: boolean,
    image?: string
    className?: string
}

export const Menu = (props: {
    items: MenuItem[],
    asRow?: boolean,
    changeView?: () => void,
    className?: string,
    color?: string

} ) => {
    const router = useNavigate();
    const currentValue = props.items.filter(i => i.active)[0]?.url;
    const [inClient, setInClient] = useState(false);
    useEffect(() => {
        startTransition(() => setInClient(true));
    }, []);

    return <div className={`d-flex ${props.className ?? ""}`}>
        <div className={`flex-fill align-self-center  ${Style.Menu1}`}>
            <ul className={`d-flex justify-content-start p-0 ${Style.Menu} radioMenu`}>
                {props.items.map((item, key) => (
                    <li key={key} className={"d-block me-5 ms-0 mt-0 mb-0"}>
                        <RouteLink to={item.url.replace(/#.+/, "")} className={`${item.active ? "active" : ""} ${item.className ?? ""}`}>
                            <span>{item.title}</span>
                        </RouteLink>
                    </li>
                ))}
            </ul>
        </div>
        <div className={`flex-fill  align-self-center  ${Style.Menu2}`}>
            <select className={"selectMenu form-select radioMenu"} onChange={e=>{
                const value = e.target.value;
                startTransition(() => router(value));
            }} value={currentValue}>
                {props.items.map((item)=> {
                    return <option key={item.url} value={item.url} className={item.url === currentValue ? "active" : ""}>{item.title}</option>
                })}
            </select>
        </div>
        {props.changeView  ?
        <div className={"align-self-center ps-4"}>
            <RouteLink to={"#"} onClick={e=>{
                e.preventDefault();
                if (props.changeView)
                    props.changeView();
            }} className={`${Style.AsItems} ${!props.asRow ? Style.activeSel : ""} ${Style.asAny}`}>
                <span>Sloupce</span>
            </RouteLink>
            &nbsp;
            <RouteLink to={"#"} onClick={e=>{
                e.preventDefault();
                if (props.changeView)
                    props.changeView();
            }} className={`${Style.AsRows} ${props.asRow ? Style.activeRow : ""} ${Style.asAny}`}>
                <span>Řádky</span>
            </RouteLink>
        </div> : false}
        {props.color ?
        <style>{`
            select.radioMenu .active {
              color: ${props.color}   !important;   
            }
            ul.radioMenu .active, ul.radioMenu a:hover {
              color: ${props.color}  !important;
            }
        `}</style> : null}
    </div>
}